var amdi18n={"__root":{"title":"Selecting a color"},"__cs":{"title":"Výběr barvy"},"__da":{"title":"Vælg en farve"},"__de":{"title":"Farbe auswählen"},"__es":{"title":"Seleccionando un color"},"__fi":{"title":"Värin valinta"},"__fr":{"title":"Sélection d'une couleur"},"__hr":{"title":"Biranje boje"},"__hu":{"title":"Szín kiválasztása"},"__it":{"title":"Selezione di un colore"},"__ja":{"title":"カラーの選択"},"__kk":{"title":"Түсті таңдау"},"__ko":{"title":"색상 선택"},"__nb":{"title":"Velge en farge"},"__nl":{"title":"Een kleur selecteren"},"__no":{"title":"Velge en farge"},"__pl":{"title":"Wybieranie koloru"},"__pt":{"title":"Selecionando uma Cor"},"__pt-br":{"title":"Selecionando uma Cor"},"__ro":{"title":"Selectarea unei culori"},"__ru":{"title":"Выбор цвета"},"__sl":{"title":"Izbiranje barve"},"__sv":{"title":"Välj en färg"},"__th":{"title":"การเลือกสี"},"__tr":{"title":"Renk seçme"},"__zh":{"title":"选择颜色"},"__zh-cn":{"title":"选择颜色"},"__zh-hk":{"title":"選取顏色"},"__zh-mo":{"title":"選取顏色"},"__zh-sg":{"title":"选择颜色"},"__zh-tw":{"title":"選取顏色"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;